import React, { Component } from "react";
import { connect } from "react-redux";
import { List } from "material-ui/List";
import Divider from "material-ui/Divider";
import CircularProgress from "material-ui/CircularProgress";
import * as standingsActions from "../store/standings/standingsActions";
import * as standingsSelectors from "../store/standings/standingsSelectors";
import * as globalStyles from "../constants/styles";
import Position from "./Position";

class Standings extends Component {
  componentDidMount() {
    const { fetchStandings } = this.props;
    fetchStandings();
  }

  render() {
    const { promotion, relegation, standings } = this.props;
    if (!standings) {
      return (
        <div style={styles.loader}>
          <CircularProgress />
        </div>
      );
    }
    return (
      <List>
        {standings.map(user => (
          <div key={`position-${user.position}`}>
            <Position
              name={user.name}
              info={user.info}
              position={user.position}
              gamePoints={user.gamePoints}
              totalPoints={user.totalPoints}
            />
            {((user.position === 2 && promotion) ||
              (user.position === 6 && relegation)) && <Divider />}
          </div>
        ))}
      </List>
    );
  }
}

const styles = {
  loader: {
    display: "flex",
    justifyContent: "center",
    padding: globalStyles.space * 2
  }
};

const mapStateToProps = (state, initialProps) => {
  const { division } = initialProps;
  return {
    standings: standingsSelectors.getStandings(state, division)
  };
};

const mapDispatchToProps = (dispatch, initialProps) => {
  const { division } = initialProps;
  return {
    fetchStandings: () => dispatch(standingsActions.fetchStandings(division))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Standings);



// WEBPACK FOOTER //
// ./src/components/Standings.js